import React from 'react';

type Props = {
  onBack: (event: React.MouseEvent<HTMLElement>) => void;
  onNext: (event: React.MouseEvent<HTMLElement>) => void;
  nextEnabled: boolean;
  backEnabled: boolean;
  backLabel: string;
  nextLabel: string;
  showBackButton?: boolean;
};

export default function NavigationFooter({
  backEnabled,
  nextEnabled,
  onBack,
  backLabel,
  nextLabel,
  onNext,
  showBackButton = true,
}: Props) {
  return (
    <footer className="sticky bottom-0 flex items-center justify-center md:justify-between px-10 py-5 backdrop-blur-xs left-0 bg-black md:bg-footer-linear-gradient w-full">
      <button
        onClick={onBack}
        disabled={!backEnabled}
        className={`md:min-w-38 min-w-full py-[10px] hidden md:block font-medium text-sm capitalize rounded-full border-2 border-grey-400 text-white-50 ${
          showBackButton ? 'visible' : 'invisible'
        }`}
      >
        {backLabel}
      </button>
      <button
        onClick={onNext}
        disabled={!nextEnabled}
        className={`px-16 py-[10px] md:min-w-38 min-w-full font-medium text-sm w-fit rounded-full ${
          nextEnabled ? 'bg-red-600' : 'border-2 border-grey-400'
        } text-white-50`}
      >
        {nextLabel}
      </button>
    </footer>
  );
}
